(() => {
  const language = (document.documentElement.lang || '').toLowerCase().split('-')[0];
  const labels = {
    da: ['Gå til betaling med leveringsbeskyttelse', 'Gå til betaling uden leveringsbeskyttelse'],
    sv: ['Till kassan med leveransskydd', 'Till kassan utan leveransskydd'],
    de: ['Zur Kasse mit Versandschutz', 'Zur Kasse ohne Versandschutz'],
    fr: ['Passer commande avec protection de livraison', 'Passer commande sans protection de livraison'],
    nl: ['Afrekenen met verzendbescherming', 'Afrekenen zonder verzendbescherming'],
    fi: ['Kassalle toimitussuojalla', 'Kassalle ilman toimitussuojaa']
  };
  const translated = labels[language];
  if (!translated) return;

  let scheduled = false;
  function updateLabels() {
    scheduled = false;
    document.querySelectorAll('.ot-estimated-shipping-protection-root .button-accept-protection').forEach(button => {
      const rawPrice = button.textContent.match(/\(([\d.,]+)\s+([A-Z]{3})\)/);
      const amount = rawPrice && Number(rawPrice[1].replace(',', '.'));
      const price = rawPrice && Number.isFinite(amount)
        ? ' (' + new Intl.NumberFormat(document.documentElement.lang, {style: 'currency', currency: rawPrice[2]}).format(amount) + ')'
        : button.textContent.match(/\s*\([^)]*\)\s*$/)?.[0] || '';
      const label = translated[0] + price;
      const textNode = button.firstChild;
      if (textNode?.nodeType === Node.TEXT_NODE && textNode.nodeValue !== label) textNode.nodeValue = label;
    });
    document.querySelectorAll('.ot-estimated-shipping-protection-root .button-normal-checkout-text').forEach(span => {
      const textNode = span.firstChild;
      if (textNode?.nodeType === Node.TEXT_NODE && textNode.nodeValue !== translated[1]) textNode.nodeValue = translated[1];
    });
  }
  const observer = new MutationObserver(() => {
    if (!scheduled) {
      scheduled = true;
      requestAnimationFrame(updateLabels);
    }
  });
  observer.observe(document.body, {childList: true, subtree: true, characterData: true});
  updateLabels();
})();